/**
 * Query params internos (ex.: mergeados pelo middleware VerificaEmpresa)
 * que não devem vazar na URL de visitas Inertia.
 */
const INTERNAL_QUERY_KEYS = ['empresa_id'] as const;

/**
 * Normaliza URL para visitas Inertia sem Mixed Content.
 *
 * O paginator Laravel pode devolver URLs absolutas com scheme `http`
 * (APP_URL / proxy SSL). Inertia/Axios em página HTTPS bloqueiam isso.
 * Usamos apenas pathname + search (+ hash) relativo à origem atual.
 */
export function toInertiaUrl(url: string): string {
    const origin =
        typeof window !== 'undefined' ? window.location.origin : 'http://localhost';

    try {
        const parsed = new URL(url, origin);

        for (const key of INTERNAL_QUERY_KEYS) {
            parsed.searchParams.delete(key);
        }

        const search = parsed.searchParams.toString();
        return `${parsed.pathname}${search ? `?${search}` : ''}${parsed.hash}`;
    } catch {
        return url.startsWith('/') ? url : `/${url}`;
    }
}
